import { useQuery } from '@tanstack/react-query';
import CommonApi from '../apis/common_api';
import ContactApi from '../apis/contact_api';
import EventApi from '../apis/event_api';

export function useGenders() {
  return useQuery({
    queryKey: ['genders'],
    queryFn: async () => await CommonApi.getGenders(),
  });
}
export function useColors() {
  return useQuery({
    queryKey: ['colors'],
    queryFn: async () => await CommonApi.getColors(),
  });
}
export function useBreeds() {
  return useQuery({
    queryKey: ['breeds'],
    queryFn: async () => await CommonApi.getBreeds(),
  });
}
export function useStates() {
  return useQuery({
    queryKey: ['states'],
    queryFn: async () => await CommonApi.getStates(),
  });
}

export function useContactRoles() {
  return useQuery({
    queryKey: ['contactRoles'],
    queryFn: async () => await ContactApi.getContactRoles(),
  });
}

export function useEventTypes() {
  return useQuery({
    queryKey: ['eventTypes'],
    queryFn: async () => await EventApi.getEventTypes(),
  });
}
